import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  overviewSummary: undefined,
  overviewTrend: undefined,
  listLoading: false,
  actionsLoading: false,
  error: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const slice = createSlice({
  name: "customerSuccessOverview",
  initialState: initialState,
  reducers: {
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    
    

    overviewSummaryFetched: (state, action) => {
      state.actionsLoading = false;
      state.overviewSummary = action.payload.data.data;
      state.error = null;
    },

    overviewTrendFetched: (state, action) => {
      state.actionsLoading = false;
      state.overviewTrend = action.payload.data.data;
      state.error = null;
    },

    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    }
  }
});
